'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = require('reselect');

var _electronConstants = require('../../../../../../common/electron/electronConstants');

var electronUpdateSelector = (0, _reselect.createSelector)(function (state) {
    return state.getIn(['app', 'electron', 'autoUpdate']);
}, function (state) {
    return state.getIn(['app', 'electron', 'appVersion']);
}, function (autoUpdate, version) {
    return {
        autoUpdate: autoUpdate,
        version: version,
        updateReady: autoUpdate === _electronConstants.AUTOUPDATE_STATE.READY
    };
});

exports.default = electronUpdateSelector;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/electronApp/electronUpdateSelector.js
// module id = 775
// module chunks = 0